export const ProcessConfigRouting = [
  {
    path: "/process-manage/config/list",
    name: "process-manage-config-list",
    meta: { title: "流程配置" },
    component: () => import("@/views/process-manage/process-config/list/index.vue"),
  },
  {
    hidden: true,
    path: "/process-manage/config/edit",
    name: "process-manage-config-edit",
    meta: { title: "配置流程节点" },
    component: () => import("@/views/process-manage/process-config/form/index.vue"),
  },
];
